/* eslint-disable */
var apiBaseUrl = location.protocol.concat("//").concat(window.location.host).concat("/api");

const appConfig = {
    appName: process.env.VUE_APP_TITLE,
    apiBaseUrl: apiBaseUrl,
    appInsightsKey: process.env.VUE_APP_APPLICATION_INSIGHTS_KEY
}

const appConfigPlugin = {
    install(Vue) {
        Vue.appConfig = appConfig
        Vue.prototype.$appConfig = appConfig
    }
}

export function useConfig(app) {
    app.use(appConfigPlugin)
}